import { Mail, Phone, MapPin, Clock, MessageCircle } from "lucide-react";
import MarketingShell from "@/components/marketing/MarketingShell";
import SEO from "@/components/marketing/SEO";

export default function Contact() {
  return (
    <MarketingShell>
      <SEO
        title="Contact TAXINPHO — Talk to our team in Balangir, Odisha"
        description="Get in touch with TAXINPHO. Email taxinpho@gmail.com or call +91 95564 72222 / 88950 06864. Office at Shree Krishna Kutir, Balangir, Odisha. Mon–Sat, 10 AM – 7 PM IST."
        canonical="https://taxinpho.co/contact"
      />
      <section className="max-w-5xl mx-auto px-5 py-16 md:py-24">
        <p className="text-xs font-bold uppercase tracking-widest text-[#002FA7] mb-3">Contact</p>
        <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter mb-6">
          Talk to us.
        </h1>
        <p className="text-zinc-600 text-lg leading-relaxed mb-12 max-w-2xl">
          Have a question about TAXINPHO, need help with your subscription, or want
          to suggest a feature? Reach out — we read every message.
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12">
          <div className="border border-zinc-200 p-7">
            <Mail size={22} className="text-[#002FA7] mb-3" />
            <p className="text-xs font-bold uppercase tracking-widest text-zinc-500 mb-1.5">Email</p>
            <a href="mailto:taxinpho@gmail.com" data-testid="contact-email" className="font-display font-bold text-2xl tracking-tight text-zinc-900 hover:text-[#002FA7] block">
              taxinpho@gmail.com
            </a>
            <p className="text-sm text-zinc-600 mt-2">Response within 24 working hours</p>
          </div>

          <div className="border border-zinc-200 p-7">
            <Phone size={22} className="text-[#002FA7] mb-3" />
            <p className="text-xs font-bold uppercase tracking-widest text-zinc-500 mb-1.5">Phone</p>
            <a href="tel:+919556472222" data-testid="contact-phone" className="font-display font-bold text-2xl tracking-tight text-zinc-900 hover:text-[#002FA7] block">
              +91 95564 72222
            </a>
            <a href="tel:+918895006864" data-testid="contact-phone-alt" className="font-display font-bold text-xl tracking-tight text-zinc-700 hover:text-[#002FA7] block mt-1">
              +91 88950 06864
            </a>
            <p className="text-sm text-zinc-600 mt-2">Mon–Sat · 10:00 AM – 7:00 PM IST</p>
          </div>

          <div className="border border-zinc-200 p-7">
            <MessageCircle size={22} className="text-[#039855]" />
            <p className="text-xs font-bold uppercase tracking-widest text-zinc-500 mb-1.5 mt-3">WhatsApp</p>
            <a href="https://wa.me/919556472222" target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="font-display font-bold text-2xl tracking-tight text-zinc-900 hover:text-[#039855] block">
              +91 95564 72222
            </a>
            <p className="text-sm text-zinc-600 mt-2">Fastest response · text us anytime</p>
          </div>

          <div className="border border-zinc-200 p-7">
            <MapPin size={22} className="text-[#002FA7] mb-3" />
            <p className="text-xs font-bold uppercase tracking-widest text-zinc-500 mb-1.5">Office</p>
            <p className="font-display font-bold text-lg tracking-tight text-zinc-900 leading-snug">
              TAXINPHO<br />
              Shree Krishna Kutir, Shree Ram Colony,<br />
              Thikadar Para, Balangir<br />
              Odisha, India - 767001
            </p>
            <p className="text-sm text-zinc-600 mt-2 flex items-center gap-1.5">
              <Clock size={12} /> Mon–Sat · 10 AM – 7 PM IST
            </p>
          </div>
        </div>

        <div className="bg-zinc-50 border border-zinc-200 p-5 mb-6 text-sm text-zinc-700">
          <p><strong>Legal name:</strong> TAXINPHO (Proprietor: Nirmala Agrawal)</p>
          <p><strong>Trade License No:</strong> <span className="font-mono">TL/BLR/2023-07-14/033462</span> · issued by Balangir Municipality</p>
        </div>

        <div className="bg-[#EFF4FF] border border-[#002FA7] p-7">
          <h3 className="font-display font-bold text-2xl tracking-tight mb-3">For billing &amp; subscription queries</h3>
          <p className="text-zinc-700 mb-2 leading-relaxed">
            If you have questions about your trial, subscription, payment, refund, or
            cancellation, please email
            <a href="mailto:taxinpho@gmail.com" className="text-[#002FA7] font-semibold underline mx-1">taxinpho@gmail.com</a>
            with your registered email address. We&apos;ll respond within one working day.
          </p>
        </div>
      </section>
    </MarketingShell>
  );
}
